module.exports = __webpack_public_path__ + "static/media/1-svg.546e2f5d.svg";